let limited_product = false
const createCartObject = (productVariant, productProperties) =>{
    let cart_item_add = {
        "items": [
            {
                "quantity": 1,
                "id": productVariant,
                "properties": productProperties,
            }
        ]
    };
    return cart_item_add;
}
var handleModalAddToCartButtons = function () {
    document.querySelectorAll(".product-cart-add").forEach(function (element) {
        element.addEventListener("click", function (event) {
            event.preventDefault();
            let limited_product = false;

            if (this.dataset.limited != "false") {
                limited_product = parseInt(this.dataset.limited);
            }

            let cart_quantity = parseInt(this.dataset.quantity);
            const properties = {};

            if (limited_product && cart_quantity >= limited_product) {
                alert(`At this time there is a purchase maximum of ${limited_product} for this product, which you have met`);
                return;
            } else {
                this.dataset.quantity++;
                currentProductVariant = this.dataset.variantId;
                currentProductPrice = this.dataset.price;
                doModalAddToCart(currentProductVariant, properties);
            }
        });
    });
},
handleModalCartPlusButton = function () {
    document.querySelectorAll(".product-cart-plus").forEach(function (element) {
        element.addEventListener("click", function (event) {
            event.preventDefault();

            let quantity = Number(document.querySelector("#add-modal-qty").value);
            if (limited_product && quantity >= limited_product) {
                alert(`At this time there is a purchase maximum of ${limited_product} for this product, which you have met`);
            } else {
                document.querySelector(`[data-variant-id='${currentProductVariant}'].product-cart-add`).dataset.quantity++;
                
                let totalItems = parseInt(document.getElementById("add-modal-items").innerHTML.split(" ")[0]);
                let productPrice = currentProductPrice * 0.01;
                let totalPrice = parseFloat(document.getElementById("add-modal-total").innerHTML.split("$")[1]);
                let finalPrice = (productPrice + totalPrice).toFixed(2);

                document.getElementById("add-modal-items").textContent = (totalItems + 1) + " items";
                document.getElementById("add-modal-total").textContent = "$" + finalPrice;
                document.querySelector("#add-modal-qty").value = quantity + 1;

                let cart_item_add = createCartObject(currentProductVariant, null);
                quantity == 0
                    ? utils.cart.addProduct(cart_item_add, currentProductPrice)
                    : doModalAddToCartUpdate(++quantity);
            }
        });
    });
},

handleModalCartMinusButton = function () {
    document.querySelectorAll(".product-cart-minus").forEach(function (element) {
        element.addEventListener("click", function (event) {
            event.preventDefault();

            let item_quantity = Number(document.querySelector("#add-modal-qty").value);
            let totalItems = parseInt(document.getElementById("add-modal-items").innerHTML.split(" ")[0]);
            let productPrice = currentProductPrice * 0.01;
            let totalPrice = parseFloat(document.getElementById("add-modal-total").innerHTML.split("$")[1]);
            let finalPrice = (totalPrice - productPrice).toFixed(2);

            if (item_quantity != 0) {
                document.querySelector(`[data-variant-id='${currentProductVariant}'].product-cart-add`).dataset.quantity--;
                item_quantity--;

                document.getElementById("add-modal-items").textContent = (totalItems - 1) + " items";
                document.getElementById("add-modal-total").textContent = "$" + finalPrice;
                document.querySelector("#add-modal-qty").value = item_quantity;

                doModalAddToCartUpdate(item_quantity);
            }
        });
    });
};

function doModalAddToCart(productVariant, productProperties) {
    cart_item_add = createCartObject(productVariant, productProperties);
    utils
        .cart
        .addProduct(cart_item_add, currentProductPrice)
        .then(data => {
            document.querySelector("#add-modal-img").innerHTML = "<img src=\"" + data.image + "\" class=\"img-fluid\" loading=\"eager\" />";
            
            if (data.title.includes('|')) {
                const variant_title = data.title.split('|');
                const title = variant_title[0];
                const packString = `Units per Case: ${variant_title[1]} - Save: $${(variant_title[2] / 100).toFixed(2)}`;
                document.querySelector("#add-modal-title").textContent = title;
                document.querySelector("#packString").textContent = packString;
            } else {
                document.querySelector("#add-modal-title").textContent = data.title;
                document.querySelector("#packString").textContent = '';
            }

let modalDesc = document.querySelector("#add-modal-desc");
if (modalDesc) {
    modalDesc.textContent = data.product_description;
}

            document.querySelector("#add-modal-qty").value = data.quantity;
            
            utils
                .cart
                .updateCount()
                .then(data => {
                    for (let i = 0; i < data.items.length; i++) {
                        let item = data.items[i];
                        if (item.variant_id == currentProductVariant && currentProductPrice != item.discounted_price) {
                            currentProductPrice = item.discounted_price;
                        }
                    }

                    document.querySelector("#add-modal-items").textContent = data.item_count + " items";
                    document.querySelector("#add-modal-total").textContent = "$" + (
                        parseInt(data.total_price) * 0.01
                    ).toFixed(2);
                });

            // Show the modal (you need to use a Bootstrap compatible way in vanilla JS)
            document.getElementById("addedToCart").style.display = 'block'
          document.getElementById("addedToCart").classList.add('show');
        });
}

function doModalAddToCartUpdate(qty) {
    qty = (qty < 1)
        ? 0
        : qty;
    utils.cart.updateProduct(currentProductVariant, qty);
}

function handleModalDismissal() {
    document.querySelectorAll('[data-dismiss="modal"]').forEach(function(element) {
        element.addEventListener("click", function(event) {
            event.preventDefault();
          document.getElementById("addedToCart").classList.remove('show');

           document.getElementById("addedToCart").style.display = 'none'
        });
    });
}

// Call the function to bind the dismissal logic
handleModalDismissal();

handleModalAddToCartButtons(),
handleModalCartPlusButton(),
handleModalCartMinusButton();